module.exports = __webpack_public_path__ + "static/media/money1.a1664870.jpg";